// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: 2Bdvl1-Hq6hK
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PaymentRequestButton from "../../PaymentRequestButton"; // plasmic-import: r_kbz56Mu6kg/component
import Invoicebutton from "../../Invoicebutton"; // plasmic-import: b1hgvbj2xTPB/component
import Subscriptionbutton from "../../Subscriptionbutton"; // plasmic-import: qWGgPtz5Kyr_/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicCreateNewElement.module.css"; // plasmic-import: 2Bdvl1-Hq6hK/css
import Rect3338Icon from "./icons/PlasmicIcon__Rect3338"; // plasmic-import: kwdRRkFFLV8f/icon

createPlasmicElementProxy;

export const PlasmicCreateNewElement__VariantProps = new Array("postClick");

export const PlasmicCreateNewElement__ArgProps = new Array();

const $$ = {};

function PlasmicCreateNewElement__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "postClick",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.postClick
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root,
        { [sty.rootpostClick]: hasVariant($state, "postClick", "postClick") }
      )}
    >
      {(hasVariant($state, "postClick", "postClick") ? true : false) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__gobZg, {
            [sty.freeBoxpostClick__gobZgaZ6Pv]: hasVariant(
              $state,
              "postClick",
              "postClick"
            )
          })}
        >
          <Rect3338Icon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg)}
            role={"img"}
          />

          <div
            className={classNames(projectcss.all, sty.freeBox__tnsUb, {
              [sty.freeBoxpostClick__tnsUBaZ6Pv]: hasVariant(
                $state,
                "postClick",
                "postClick"
              )
            })}
          >
            <PaymentRequestButton
              data-plasmic-name={"debtButton"}
              data-plasmic-override={overrides.debtButton}
              className={classNames("__wab_instance", sty.debtButton, {
                [sty.debtButtonpostClick]: hasVariant(
                  $state,
                  "postClick",
                  "postClick"
                )
              })}
            />

            <Invoicebutton
              data-plasmic-name={"invoiceButton"}
              data-plasmic-override={overrides.invoiceButton}
              className={classNames("__wab_instance", sty.invoiceButton, {
                [sty.invoiceButtonpostClick]: hasVariant(
                  $state,
                  "postClick",
                  "postClick"
                )
              })}
            />

            <Subscriptionbutton
              data-plasmic-name={"subscriptionButton"}
              data-plasmic-override={overrides.subscriptionButton}
              className={classNames("__wab_instance", sty.subscriptionButton, {
                [sty.subscriptionButtonpostClick]: hasVariant(
                  $state,
                  "postClick",
                  "postClick"
                )
              })}
            />

            <Invoicebutton
              data-plasmic-name={"invoiceButton2"}
              data-plasmic-override={overrides.invoiceButton2}
              className={classNames("__wab_instance", sty.invoiceButton2, {
                [sty.invoiceButton2postClick]: hasVariant(
                  $state,
                  "postClick",
                  "postClick"
                )
              })}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "svg",
    "debtButton",
    "invoiceButton",
    "subscriptionButton",
    "invoiceButton2"
  ],

  svg: ["svg"],
  debtButton: ["debtButton"],
  invoiceButton: ["invoiceButton"],
  subscriptionButton: ["subscriptionButton"],
  invoiceButton2: ["invoiceButton2"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCreateNewElement__ArgProps,
          internalVariantPropNames: PlasmicCreateNewElement__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCreateNewElement__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCreateNewElement";
  } else {
    func.displayName = `PlasmicCreateNewElement.${nodeName}`;
  }
  return func;
}

export const PlasmicCreateNewElement = Object.assign(
  // Top-level PlasmicCreateNewElement renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),
    debtButton: makeNodeComponent("debtButton"),
    invoiceButton: makeNodeComponent("invoiceButton"),
    subscriptionButton: makeNodeComponent("subscriptionButton"),
    invoiceButton2: makeNodeComponent("invoiceButton2"),
    // Metadata about props expected for PlasmicCreateNewElement
    internalVariantProps: PlasmicCreateNewElement__VariantProps,
    internalArgProps: PlasmicCreateNewElement__ArgProps
  }
);

export default PlasmicCreateNewElement;
/* prettier-ignore-end */
